<groundworks-modal [title]="title">
  <groundworks-modal-body>
    <form [formGroup]="form">
      <div class="row">
        <div class="col mb-3">
          <label class="form-label" for="contact-first-name">First Name <span class="text-danger">*</span></label>
          <input id="contact-first-name" class="form-control" formControlName="firstName" />
        </div>
        <div class="col mb-3">
          <label class="form-label" for="contact-last-name">Last Name <span class="text-danger">*</span></label>
          <input id="contact-last-name" class="form-control" formControlName="lastName" />
        </div>
      </div>
      <div class="mb-3">
        <label class="form-label" for="contact-phone">Phone <span class="text-danger">*</span></label>
        <input id="contact-phone" class="form-control" formControlName="phoneNumber" />
      </div>
      <div class="mb-3">
        <label class="form-label" for="contact-email">Email</label>
        <input id="contact-email" class="form-control" type="email" formControlName="email" />
      </div>
      @if (errorMessage()) {
        <p class="text-danger mb-0">{{ errorMessage() }}</p>
      }
    </form>
  </groundworks-modal-body>
  <groundworks-modal-footer [actions]="footerActions()" />
</groundworks-modal>
